/* Match individual source image files, never a whole product or a variant. */
(() => {
  const configuration = document.getElementById('MbmProductPhotoAssets');
  if (!configuration) return;
  let photos;
  try { photos = JSON.parse(configuration.textContent); } catch { return; }
  const update = element => {
    if (!(element instanceof Element) || element.tagName !== 'IMG') return;
    const current = ['src','srcset','data-src','data-srcset'].map(name => element.getAttribute(name) || '').join(' ');
    const photo = photos.find(item => current.includes(item.source));
    if (!photo) return;
    element.setAttribute('src', photo.url);
    element.removeAttribute('srcset');
    if (element.hasAttribute('data-src')) element.setAttribute('data-src', photo.url);
    if (element.hasAttribute('data-srcset')) element.removeAttribute('data-srcset');
    element.classList.add('mbm-studio-photo');
    const zoom = element.closest('a');
    if (zoom?.getAttribute('href')?.includes(photo.source)) zoom.setAttribute('href', photo.url);
  };
  const scan = scope => {
    update(scope);
    scope.querySelectorAll?.('img').forEach(update);
  };
  scan(document);
  // Builder galleries and native variant updates may insert images after page load.
  const observer = new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') update(record.target);
    else record.addedNodes.forEach(scan);
  }));
  const main = document.getElementById('MainContent');
  if (main) observer.observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['src','srcset','data-src','data-srcset'] });
})();
